"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/babel-runtime/helpers/classCallCheck.js
// module id = 947
// module chunks = 48 49 50